import { useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import CloseIcon from '@material-ui/icons/Close';
import { useForm, Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import DateRangePickerML from '@/components/DateRangePickerML';
import { OPT_DETAIL, OPT_ADD } from '@/constants.js';
import { prizeLimitData, userPrizeLimitData } from '../../constants';
import { TextFieldCom, SelectFieldCom } from '@/components/FormType';
import webStorage from '@/utils/storageManager';
import HeadlineML from '../HeadlineML';
import Styled from './styles';

export default ({
  id,
  status,
  defaultValuesData,
  queryType,
  handleExitClick,
  handleSubmitSuccessBase,
  handleSubmitFailBase,
}) => {
  const { control, setValue, errors, getValues, watch, handleSubmit, reset } =
    useForm();
  //活动玩法列表
  const LUCKY_TYPE = webStorage
    .get('DICTOBJ')
    ?.ACTIVITY_LOTTERY_TYPE?.map((item) => ({
      name: item.nameZh,
      value: item.dictCode,
      disabled: item.dictCode === 'SUDOKU',
    }))
    ?.filter(
      (item) => item.value !== 'SHAKE_IT_OFF' && item.value !== 'SCRATCH_CARD',
    );
  useEffect(() => {
    if (defaultValuesData) {
      reset(defaultValuesData);
    }
  }, [defaultValuesData, reset]);
  console.log(watch('watch', watch()));

  return (
    <Styled>
      <form
        onSubmit={handleSubmit(handleSubmitSuccessBase, handleSubmitFailBase)}
      >
        <div className="from-content">
          <div className="left-content">
            <HeadlineML title="基本信息" />
            <TextFieldCom
              control={control}
              label="活动名称"
              name="name"
              getValues={getValues}
              setValue={setValue}
              errors={errors}
              initErrorText="请填写中文、英文和数字，不可超过30个字"
              disabled={status === '1' || queryType === OPT_DETAIL}
              rules={{
                required: true,
                maxLength: 30,
                pattern: /^[\u4e00-\u9fa5a-zA-Z0-9._]*$/,
              }}
            />
            <FormControl variant="standard">
              <Controller
                render={(rp) => (
                  <DateRangePickerML
                    label="开始时间"
                    title="结束时间"
                    minDate={(!id && new Date()) || null}
                    startText={
                      <>
                        <span style={{ color: 'red' }}>*</span>
                        开始时间
                      </>
                    }
                    endText={
                      <>
                        <span style={{ color: 'red' }}>*</span>
                        结束时间
                      </>
                    }
                    defaultStartDate={defaultValuesData?.beginDateTime}
                    defaultEndDate={defaultValuesData?.endDateTime}
                    rp={rp}
                    setValue={setValue}
                    name="date"
                    control={control}
                    disabled={queryType === OPT_DETAIL}
                  />
                )}
                name="date"
                control={control}
                rules={{
                  validate: {
                    required: () => {
                      return !(
                        !getValues('date') ||
                        !getValues('date')?.startDate ||
                        !getValues('date')?.endDate
                      );
                    },
                    isDisabled: () => {
                      const d =
                        status &&
                        getValues('date')?.startDate &&
                        dayjs(getValues('date')?.startDate).format(
                          'YYYY-MM-DD',
                        ) !==
                          dayjs(defaultValuesData.beginDateTime).format(
                            'YYYY-MM-DD',
                          );
                      return !d;
                    },
                  },
                }}
              />
              <FormHelperText error={Boolean(errors.date)}>
                {Boolean(errors.date?.type === 'required') && '日期是必填项'}
                {Boolean(errors.date?.type === 'isDisabled') &&
                  '进行中的活动开始时间不能修改'}
              </FormHelperText>
            </FormControl>
            <div>
              <SelectFieldCom
                label="活动玩法"
                name="type"
                control={control}
                errors={errors}
                getValues={getValues}
                setValue={setValue}
                typeList={LUCKY_TYPE}
                watchAllFields={watch()}
                rules={{ required: true }}
                disabled={status === '1' || queryType === OPT_DETAIL}
              />
            </div>
            <FormControl variant="standard" style={{ marginBottom: '24px' }}>
              <div className="hit-rate-wrap">
                <label>
                  <span>*</span>中奖概率
                </label>
                <div className="hit-rate-input-wrap">
                  <TextFieldCom
                    control={control}
                    label="中奖概率"
                    showLabel={false}
                    name="hitRate"
                    isNumber={true}
                    isPositiveNumber={true}
                    decimalMark="2"
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    showError={false}
                    disabled={queryType === OPT_DETAIL}
                    rules={{
                      required: true,
                      min: 0,
                      max: 100,
                    }}
                  />
                </div>
                <label>%</label>
              </div>
              <div className="mention">
                此处配置的中奖概率为包含所有奖项的活动中奖概率
              </div>
              <FormHelperText
                error={Boolean(errors.hitRate)}
                sx={{ position: 'relative', top: '-10px' }}
              >
                {Boolean(errors.hitRate) && '请填写大于0，小于或等于100数字'}
              </FormHelperText>
            </FormControl>
            <TextFieldCom
              label="活动规则"
              showError={true}
              control={control}
              name="description"
              setValue={setValue}
              getValues={getValues}
              disabled={status === '1' || queryType === OPT_DETAIL}
              rules={{
                required: true, //是否是必填项true 必填 false
                maxLength: 2000,
              }}
              errors={errors}
              multiline={true}
              maxRows="8"
              minRows="8"
              variant="outlined"
              textClassName="textField-area-wrap"
              placeholder="请输入"
            />
          </div>
          <div className="middle-content"></div>
          <div className="right-content">
            <HeadlineML
              title="抽奖次数获取方式"
              subTitle="满足以下设置条件抽奖次数自动发放"
            />
            <Box display="flex" flexDirection="column" gap="6px">
              {prizeLimitData.map((item) => {
                return (
                  <>
                    <Box display="flex" gap="0 4px" key={item.id}>
                      <Controller
                        name={item.checkName}
                        control={control}
                        render={(field) => {
                          return (
                            <Checkbox
                              disabled={
                                status === '1' || queryType === OPT_DETAIL
                              }
                              style={{
                                ...((status === '1' ||
                                  queryType === OPT_DETAIL) && {
                                  color: 'darkgray',
                                }),
                              }}
                              className="checkbox-radio-disabled-color"
                              // 关键：将 react-hook-form 的字段属性绑定到 Checkbox
                              checked={field.value || false}
                              onChange={(e) => {
                                return field.onChange(e.target.checked);
                              }}
                            />
                          );
                        }}
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          color: '#212100',
                        }}
                      >
                        {item.leftWord}
                      </Box>
                      <TextFieldCom
                        key={item.id}
                        style={{ width: '70px' }}
                        autoFocus={false} //If true, the input element is focused during the first mount.
                        initLabel={false} //自定义的label是否显示
                        showLabel={false} //是否需要显示label
                        // placeholder="0"
                        disabled={status === '1' || queryType === OPT_DETAIL}
                        helperText="必填项" //用于校验的提醒文字
                        initErrorText="必填项"
                        name={item.name}
                        label="" //label
                        control={control}
                        errors={errors}
                        getValues={getValues}
                        setValue={setValue}
                        isNumber={true}
                        isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                        isParseInt={true} //true 只能输入整数，false可以输入小数
                        showError={true} //false输入框捕获到错误不展示错误样式，默认true
                        thousands={true} //是否需要千分位
                        rules={{
                          required: watch(item.checkName),
                          min: watch(item.checkName) ? 1 : '',
                          max: watch(item.checkName) ? 9999 : '',
                        }}
                      />
                      {item.midWord && (
                        <>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              color: '#212100',
                            }}
                          >
                            {item.midWord}
                          </Box>
                          <TextFieldCom
                            key={item.id}
                            style={{ width: '70px' }}
                            autoFocus={false} //If true, the input element is focused during the first mount.
                            initLabel={false} //自定义的label是否显示
                            showLabel={false} //是否需要显示label
                            // placeholder="0"
                            disabled={
                              status === '1' || queryType === OPT_DETAIL
                            }
                            helperText="必填项" //用于校验的提醒文字
                            initErrorText="必填项"
                            name={item.midName}
                            label="" //label
                            control={control}
                            errors={errors}
                            getValues={getValues}
                            setValue={setValue}
                            isNumber={true}
                            isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                            isParseInt={true} //true 只能输入整数，false可以输入小数
                            showError={true} //false输入框捕获到错误不展示错误样式，默认true
                            thousands={true} //是否需要千分位
                            rules={{
                              required: watch(item.checkName),
                              min: watch(item.checkName) ? 1 : '',
                              max: watch(item.checkName) ? 9999 : '',

                              //是否是必填项true 必填 false 非必填1
                            }}
                          />
                        </>
                      )}
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          color: '#212100',
                        }}
                      >
                        次抽奖
                      </Box>

                      {/* ------ */}
                      {item.thirdWord && (
                        <>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              color: '#212100',
                            }}
                          >
                            {item.thirdWord}
                          </Box>
                          <TextFieldCom
                            key={item.id}
                            style={{ width: '70px' }}
                            autoFocus={false} //If true, the input element is focused during the first mount.
                            initLabel={false} //自定义的label是否显示
                            showLabel={false} //是否需要显示label
                            // placeholder="0"
                            disabled={
                              status === '1' || queryType === OPT_DETAIL
                            }
                            helperText="必填项" //用于校验的提醒文字
                            initErrorText="必填项"
                            name={item.thirdName}
                            label="" //label
                            control={control}
                            errors={errors}
                            thousands={true}
                            getValues={getValues}
                            setValue={setValue}
                            isNumber={true}
                            isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                            isParseInt={true} //true 只能输入整数，false可以输入小数
                            showError={true} //false输入框捕获到错误不展示错误样式，默认true
                            rules={{
                              required: watch(item.checkName),
                              min: watch(item.checkName) ? 1 : '',
                              max: watch(item.checkName) ? 9999 : '',
                            }}
                          />
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              color: '#212100',
                            }}
                          >
                            次抽奖
                          </Box>
                        </>
                      )}
                    </Box>

                    <Box
                      pl={5}
                      display={
                        watch('isRegister') && item.checkName === 'isRegister'
                          ? 'block'
                          : 'none'
                      }
                    >
                      <Box mb={3}>
                        <FormControl variant="standard">
                          <Controller
                            render={(rp) => (
                              <DateRangePickerML
                                label="注册开始时间"
                                title="注册结束时间"
                                startText={
                                  <>
                                    <span style={{ color: 'red' }}>*</span>
                                    注册开始时间
                                  </>
                                }
                                endText={
                                  <>
                                    <span style={{ color: 'red' }}>*</span>
                                    注册结束时间
                                  </>
                                }
                                defaultStartDate={
                                  queryType !== OPT_ADD
                                    ? defaultValuesData?.registerBeginDateTime
                                      ? defaultValuesData?.registerBeginDateTime
                                      : getValues('date')?.startDate ||
                                        defaultValuesData?.beginDateTime
                                    : null
                                }
                                defaultEndDate={
                                  queryType !== OPT_ADD
                                    ? defaultValuesData?.registerEndDateTime
                                      ? defaultValuesData?.registerEndDateTime
                                      : getValues('date')?.endDate ||
                                        defaultValuesData?.endDateTime
                                    : null
                                }
                                rp={rp}
                                setValue={setValue}
                                name="dateReg"
                                control={control}
                                disabled={
                                  status === '1' || queryType === OPT_DETAIL
                                }
                              />
                            )}
                            name="dateReg"
                            control={control}
                            rules={{
                              validate: {
                                required: () =>
                                  !(
                                    watch('isRegister') &&
                                    (!getValues('dateReg') ||
                                      !getValues('dateReg')?.startDate ||
                                      !getValues('dateReg')?.endDate)
                                  ),
                              },
                            }}
                          />
                          <FormHelperText error={Boolean(errors.dateReg)}>
                            {Boolean(errors.dateReg?.type === 'required') &&
                              '日期是必填项'}
                            {/* {Boolean(errors.dateReg?.type === 'isDisabled') &&
                    '进行中的活动开始时间不能修改'} */}
                          </FormHelperText>
                        </FormControl>
                      </Box>
                    </Box>
                  </>
                );
              })}
            </Box>
            <HeadlineML title="抽奖管控" style={{ marginTop: 34 }} />
            <Box display="flex" flexDirection="column" gap="6px">
              {userPrizeLimitData.map((item, index) => {
                return (
                  <>
                    <Box display="flex" gap="0 4px" key={item.id}>
                      <Controller
                        name={item.checkName}
                        control={control}
                        render={(field) => (
                          <Checkbox
                            disabled={
                              status === '1' || queryType === OPT_DETAIL
                            }
                            style={{
                              ...((status === '1' ||
                                queryType === OPT_DETAIL) && {
                                color: 'darkgray',
                              }),
                            }}
                            className="checkbox-radio-disabled-color"
                            // 关键：将 react-hook-form 的字段属性绑定到 Checkbox
                            checked={field.value || false}
                            onChange={(e) => {
                              return field.onChange(e.target.checked);
                            }}
                          />
                        )}
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          color: '#212100',
                        }}
                      >
                        {item.leftWord}
                      </Box>
                      <TextFieldCom
                        key={item.id}
                        style={{ width: '70px' }}
                        autoFocus={false} //If true, the input element is focused during the first mount.
                        initLabel={false} //自定义的label是否显示
                        showLabel={false} //是否需要显示label
                        // placeholder="0"
                        disabled={status === '1' || queryType === OPT_DETAIL}
                        helperText="必填项" //用于校验的提醒文字
                        initErrorText="必填项"
                        name={item.name}
                        label="" //label
                        control={control}
                        errors={errors}
                        getValues={getValues}
                        setValue={setValue}
                        isNumber={true}
                        isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                        isParseInt={true} //true 只能输入整数，false可以输入小数
                        showError={true} //false输入框捕获到错误不展示错误样式，默认true
                        thousands={true} //是否需要千分位
                        rules={{
                          required: watch(item.checkName),
                          min: watch(item.checkName) ? 1 : '',
                          max: watch(item.checkName) ? 9999 : '',
                        }}
                      />
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          color: '#212100',
                        }}
                      >
                        {index === 0 ? '次抽奖' : '次'}
                      </Box>
                    </Box>
                  </>
                );
              })}
            </Box>
          </div>
        </div>
        <div className="from-button-wrap">
          <Button variant="contained" className="goFront" type="submit">
            下一页
          </Button>
          <div
            style={{
              height: '40px',
              width: '1px',
              backgroundColor: '#E5E5E5',
            }}
          ></div>
          <Button
            color="secondary"
            variant="contained"
            className="exit"
            onClick={handleExitClick}
            startIcon={<CloseIcon sx={{ width: '20px', height: '20px' }} />}
          >
            退出
          </Button>
        </div>
      </form>
    </Styled>
  );
};
